import { Redirect, Route as PublicRoute, Switch } from 'react-router-dom';
import React from 'react';

import { PrivateRoute } from 'core/helpers';
import { Login as LoginRouter } from './Login';
import { DevRouter } from './Dev';
import { UserRouter } from './User';
import { AdministrationRouter } from './Administration';
import { UserManagementRouter } from './UserManagement';
import { AdministratorToolsRouter } from './AdministratorTools';
import { CreditTransfersRouter } from './CreditTransfers';
import { LogoutRouter } from './Logout';
import { PageNotFoundRouter } from './PageNotFound';
import { DashboardRouter } from './Dashboard';
import { FromTemplateRouter } from './FromTemplate';
import { AboutRouter } from './About';
import { TransactionsRouter } from './Transactions';
import { DownloadCenterRouter } from './DownloadCenter';
import { LogRouter } from './Log';

export const MainRouter = () => (
  <Switch>
    <Redirect from='/' to='/login' exact />
    <Redirect from='/public/login/' to='/login' exact />

    <PrivateRoute path='/dashboard' exact>
      <DashboardRouter />
    </PrivateRoute>

    <PrivateRoute path='/dev'>
      <DevRouter />
    </PrivateRoute>

    <PrivateRoute path='/from-templates'>
      <FromTemplateRouter />
    </PrivateRoute>

    <PrivateRoute path='/administrator-tools'>
      <AdministratorToolsRouter />
    </PrivateRoute>

    <PrivateRoute path='/log'>
      <LogRouter />
    </PrivateRoute>

    <PrivateRoute path='/administration'>
      <AdministrationRouter />
    </PrivateRoute>

    <PrivateRoute path='/user'>
      <UserRouter />
    </PrivateRoute>

    <PrivateRoute path='/userManagement'>
      <UserManagementRouter />
    </PrivateRoute>

    <PrivateRoute path='/payments'>
      <CreditTransfersRouter />
    </PrivateRoute>

    <PrivateRoute path='/transactions'>
      <TransactionsRouter />
    </PrivateRoute>

    <PrivateRoute path='/DLC'>
      <DownloadCenterRouter />
    </PrivateRoute>

    <PublicRoute path='/login'>
      <LoginRouter />
    </PublicRoute>

    <PublicRoute path='/logout' exact>
      <LogoutRouter />
    </PublicRoute>

    <PrivateRoute path='/about'>
      <AboutRouter />
    </PrivateRoute>

    <PublicRoute path='*'>
      <PageNotFoundRouter />
    </PublicRoute>
  </Switch>
);
